export enum OptionChipMode {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}
